import { useState } from 'react';

type TimerComponentProps = {
  time: string;
  minTime?: number;
  onChange: (value: string) => void;
};

export const TimerComponent = ({
  time,
  minTime = 10,
  onChange
}: TimerComponentProps) => {
  const [error, setError] = useState(minTime < 10);

  const [inputValue, setInputValue] = useState(time);

  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const { value } = event.target;

    if (/^[0-9]*$/.test(value) || value === '') {
      setInputValue(value);
      onChange(value);
    }

    if (+value < 10) {
      setError(true);
    } else setError(false);
  };

  const handleBlur = () => {
    if (inputValue === '') {
      setInputValue('0');
    }
  };

  const handleFocus = () => {
    if (inputValue === '0') {
      setInputValue('');
    }
  };

  return (
    <div className="tw-flex tw-gap-3 tw-items-center">
      <input
        value={inputValue}
        onChange={handleChange}
        onBlur={handleBlur}
        onFocus={handleFocus}
        className={`
        ${
          error
            ? 'tw-border-[#AA2C23] tw-outline-[#AA2C23]'
            : 'tw-border-[#001E64] tw-outline-[#001E64]'
        }
        tw-border-[1px] tw-rounded-md tw-w-[3.75rem] tw-h-[3.125rem] tw-flex tw-justify-center tw-items-center tw-text-center tw-font-bold tw-text-xl`}
      />
      {error ? (
        <div className="tw-text-[#AA2C23] tw-text-sm">
          <p>O tempo mínimo</p>
          <p>
            para transbordo é de <b>10 minutos</b>.
          </p>
        </div>
      ) : (
        <p>Minutos</p>
      )}
    </div>
  );
};
